import { Component, Host, h, Prop } from '@stencil/core';

@Component({
    tag: 'icon-search',
    shadow: true,
})
export class IconSearch {
    @Prop() width = '14px';
    @Prop() height = '14px';
    @Prop() color = 'currentColor';

    render() {
        return (
            <svg
                fill={this.color}
                width={this.width}
                height={this.height}
                viewBox="0 0 14 14"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M15,14.3 L10.7,10 C12.6,7.7 12.3,4.2 10,2.3 C7.7,0.4 4.2,0.7 2.3,3 C0.4,5.3 0.7,8.8 3,10.7 C5,12.4 8,12.4 10,10.7 L14.3,15 L15,14.3 Z M2,6.5 C2,4 4,2 6.5,2 C9,2 11,4 11,6.5 C11,9 9,11 6.5,11 C4,11 2,9 2,6.5 Z"></path>
            </svg>
        );
    }
}
